import { useUserStore } from '@/store/userStore';
import { APP_MODES } from '@/helpers/constants';

export const CombinedMode = ({ children }) => {
  const mode = useUserStore(state => state.mode);
  if (mode !== APP_MODES.combined) return null;

  return children;
};